const filledQuestionsAndChoices = (quiz) => {
    const allChoices = quiz.questions[0].answers.concat(quiz.questions[1].answers)
    const choiceNumbers = allChoices.length;
    let titleCounter = 0;
    let questionsFilled = true;
    quiz.questions.forEach((question) => {
        if (!question.title) {
            questionsFilled = false
        }
    })
    allChoices.forEach((choice) => {
        if (choice.title) {
            titleCounter++;
        }
    })
    return titleCounter === choiceNumbers && questionsFilled
}
function canShowPriceButton(quiz) {
    let allCellsHaveItems = true;
    let currHighestPrice = 0;
    quiz.itemsChoices.forEach((firstChoice) => {
        firstChoice.forEach((secondChoice) => {
            if (secondChoice && secondChoice.length) {
                secondChoice.forEach(item => {
                    if (item.price >= currHighestPrice) {
                        currHighestPrice = item.price;
                    }
                });
                if (secondChoice.length < 2) {
                    allCellsHaveItems = false;
                }
            } else {
                allCellsHaveItems = false;
            }
        })
    })
    return {
        allCellsHaveItems,
        currHighestPrice
    }
}
function addItemToChoice({ quiz, item, currentTableAnswer }) {
    const [q1Index, q2Index] = currentTableAnswer
    const arrayToHanle = quiz.itemsChoices[q1Index][q2Index];
    if (!arrayToHanle || !arrayToHanle.length) {
        quiz.itemsChoices[q1Index][q2Index] = [item];
    } else {
        const foundItem = arrayToHanle.find(searchItem =>
            searchItem.itemId === item.itemId
        )
        if (foundItem) {
            return;
        } else {
            arrayToHanle.push(item)
        }
    }
}
function removeItem(quiz, e) {
    const values = e.target.attributes['data-id'] ?
        e.target.attributes['data-id'].value.split(' ') :
        e.target.parentElement.attributes['data-id'].value.split(' ')

    const [q1Index, q2Index, itemIdToRemove]
        = values;
    const arrayToHanle = quiz.itemsChoices[q1Index][q2Index];
    quiz.itemsChoices[q1Index][q2Index] = arrayToHanle.filter(item => item.itemId !== itemIdToRemove);
    return [q1Index, q2Index];
}
function calculateSegments(sliderValues, itemsChoices) {
    const [lowerPrice, highestPrice] = sliderValues
    const segmantErrors = {
        1: false,
        2: false,
        3: false,
    }
    itemsChoices.forEach((firstLevel) => {
        firstLevel.forEach((secondLevel) => {
            const countOfSegment = {
                1: 0,
                2: 0,
                3: 0,
            };
            secondLevel.forEach((item) => {
                const itemPrice = Math.floor(item.price);
                item.segment = itemPrice <= Math.floor(lowerPrice) ? 1 :
                    itemPrice >= Math.floor(lowerPrice) && itemPrice <= Math.floor(highestPrice) ? 2
                        : 3
                countOfSegment[item.segment] = countOfSegment[item.segment] ?
                    countOfSegment[item.segment] + 1 : 1
            })
            secondLevel.countOfSegment = countOfSegment;
            for (const segmant in secondLevel.countOfSegment) {
                if (!secondLevel.countOfSegment[segmant]) {
                    segmantErrors[segmant] = true;
                }
            }
        })
    })
    return segmantErrors
}
const addChoiceToQuestion = (index, quiz) => {
    const arrayToHanle = quiz.questions[index].answers;
    if (arrayToHanle.length === 5) {
        return;
    }
    const newAnswer = {
        "title": "Choice title here",
        "image": ""
    }
    arrayToHanle.push(newAnswer)
    if (index === 0) {
        quiz.itemsChoices.push(quiz.itemsChoices[0])
    } else {
        quiz.itemsChoices.forEach((choicesArray) => {
            choicesArray.push([])
        })
    }
}
export default {
    calculateSegments,
    removeItem,
    addItemToChoice,
    canShowPriceButton,
    filledQuestionsAndChoices,
    addChoiceToQuestion,
}